import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { SlideoverReducerStateIdKeys } from "@/app_redux/reducers/reducer_interface";

/* returns modal show state */
export const useSlideover = (slideoverId: SlideoverReducerStateIdKeys) => {
  const modalState = useAppSelector((state) => state.slideovers[slideoverId]);
  return modalState;
};
